import initCompareSelector from '~/projects/compare';

initCompareSelector();
